<template>
  <router-view></router-view>
</template>

<script>
import { actions } from "@/store"

export default {
  name: "project",
  props: ["projectId"],
  created() {
    this.initProjectListeners()
  },
  watch: {
    projectId() {
      this.initProjectListeners()
    }
  },
  methods: {
    initProjectListeners() {
      actions.initProjectListeners(this.projectId, e => {
        this.$router.push("/manager")
        actions.addError("read-project-error")(e)
        actions.terminateProjectListeners(this.projectId)
      })
    }
  }
}
</script>
